var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "transitionGroup",
        {
          attrs: {
            enterClass: _vm.$style.fadeEnter,
            enterActiveClass: _vm.$style.fadeEnterActive,
            leaveActiveClass: _vm.$style.fadeLeaveActive,
            leaveToClass: _vm.$style.fadeLeaveTo,
          },
        },
        [
          !_vm.success
            ? _c(
                "LoginCard",
                { key: "form", attrs: { header: _vm.headerText } },
                [
                  _c("Alert", {
                    model: {
                      value: _vm.errorMessage,
                      callback: function ($$v) {
                        _vm.errorMessage = $$v
                      },
                      expression: "errorMessage",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "form",
                    [
                      _c("LoginTextField", {
                        attrs: {
                          required: true,
                          submitOnEnter: _vm.submit,
                          autoFocus: "",
                          label: "Email",
                          name: "email",
                          placeholder: "Email Address",
                          type: "email",
                          vvName: "email",
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "LoginActionButton",
                        {
                          attrs: {
                            action: _vm.submit,
                            isLoading: _vm.isLoading,
                            type: "button",
                          },
                        },
                        [_vm._v("\n          Send Reset Request\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.success
            ? _c(
                "LoginCard",
                {
                  key: "confirmation",
                  staticClass: "email-sent-content",
                  attrs: { header: _vm.headerText },
                },
                [
                  _c("ul", { class: _vm.$style.directionsList }, [
                    _c("li", { class: _vm.$style.directions }, [
                      _vm._v(
                        "\n          A confirmation email has been sent (email address must be registered with JumpCloud).\n          "
                      ),
                      _c(
                        "a",
                        {
                          class: _vm.$style.link,
                          attrs: { href: _vm.resetEmail },
                        },
                        [
                          _vm._v(
                            "\n            Enter different email\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { class: _vm.$style.directions }, [
                      _vm._v(
                        "\n          Please follow the instructions in the email to reset your password.\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { class: _vm.$style.directions }, [
                      _vm._v(
                        "\n          Allow up to 10 minutes for the email to arrive in your inbox.\n        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "LoginActionButton",
                    { attrs: { action: _vm.goToLogin } },
                    [_vm._v("\n        Return to Login\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("LogoIcon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }